import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={75}
    height={75}
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M61.4827 41.9507C64.2925 40.9052 66.6762 39.749 68.4213 38.5948"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6602 5C5.76634 13.3522 5.53026 23.3258 7.87832 32.4442C10.8691 44.0862 13.2161 59.6727 12.1761 66.1633C11.1361 72.6612 16.7396 70.0633 20.3877 64.6106C22.7581 61.0637 25.1285 55.1911 30.0097 50.9892C32.6313 48.7301 35.9837 46.9491 40.4513 46.272C41.3597 46.1322 42.2315 45.9439 43.095 45.882C47.6886 45.5529 52.2228 44.723 56.2769 43.6162"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.62 36.0198C16.7383 40.1467 16.7173 44.1791 17.0599 46.8097C17.7058 51.7261 19.6295 61.9274 12.5209 69.4406C12.0706 68.8585 11.9114 67.7987 12.1753 66.1615C13.2169 59.6714 10.8701 44.0855 7.87755 32.4424C5.53053 23.324 5.76713 13.3501 13.6581 5"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.2759 5C42.5329 8.44707 37.356 14.4333 31.0308 19.2329"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.1787 5C56.2435 27.0714 62.2996 39.0282 62.2996 51.1125"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.0102 51.1126C57.0102 40.9523 53.2907 33.4586 48.6107 29.997C45.8456 31.7572 40.9602 33.8528 31.2318 37.2367C22.7953 40.1703 18.6429 38.1963 14.8817 32.8614C11.1206 27.5314 11.6481 21.3232 16.6328 18.7853C21.6129 16.2475 28.435 19.181 36.4804 21.4506C42.9567 23.2833 45.0125 23.2966 46.8544 23.8654C46.8679 23.8701 46.8861 23.8745 46.9043 23.8792C47.5956 24.0339 51.8661 24.8844 55.1816 30.4052C54.7178 25.9753 56.0077 13.485 59.3642 4.99988"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.082 21.6339C17.1859 22.1511 15.832 25.0659 16.4334 27.7738C17.0834 30.7012 19.4515 33.5614 23.5408 34.5408C26.8209 35.3265 32.3199 33.1267 34.8528 32.2609C38.0911 31.1538 42.7841 29.6521 42.7308 27.6664C42.6486 24.6403 35.6357 24.9448 30.5194 23.7404C25.4031 22.5361 22.3926 20.7302 19.082 21.6339Z"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="26 3.56 3.56 3.56"
    />
    <path
      d="M49.4907 29.3073C49.4907 29.3073 49.2047 29.5576 48.6109 29.997"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.8381 27.0714C50.9124 26.2288 50.5362 25.5265 50.2057 25.2181"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.1434 26.4594H29.9173L28.8045 28.3872L29.9173 30.3149H32.1434L33.2565 28.3872L32.1434 26.4594Z"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.519 25.0973H21.6252L20.1783 27.6034L21.6252 30.1096H24.519L25.9659 27.6034L24.519 25.0973Z"
      stroke="#233877"
      strokeWidth={1.78074}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;
